import React from "react";
import { Card, Button, CardTitle, CardText, Row, Col } from "reactstrap";
import "../styles/Services.css";

const Services = (props) => {
  return (
    <div className="services_main">
      <h1 className="services_heading"> Services We Provide </h1>
      <Row className="container-services">
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">Web Development</CardTitle>
            <CardText className="service_desc">
              Web development is the work involved in developing a Web site for
              the Internet(World Wide Web) or an intranet(a private network).
            </CardText>

            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">App Development</CardTitle>
            <CardText className="service_desc">
              It is the process in which an application is developed for mobile
              devices, such as smartphones and tablets.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">All types Graphics design</CardTitle>
            <CardText className="service_desc">
              Graphic design is also known as communication design, and Graphic
              Designers are essentially visual communicators.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
      </Row>
      <Row className="container-services">
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">E-MAIL Services</CardTitle>
            <CardText className="service_desc desc-middle">
              We provide their clients a dedicated email service. The clients
              can choose from a range of services such as Business Email, email
              marketing via Amazon ses and dedicated. SMTP for the email
              marketing.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">Video Editing</CardTitle>
            <CardText className="service_desc desc-middle">
              Video editing is the process of editing segments of motion video
              production footage, special effects and sound recordings in the
              post-production process.
            </CardText>

            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">BULK SMS</CardTitle>
            <CardText className="service_desc desc-middle">
              Wanting to promote your product or service through personalised
              SMS? we comes With various bulk SMS planning. We offers their
              client three different bulk SMS planning such as promotional Bulk
              SMS.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
      </Row>

      <Row className="container-services">
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">Digital marketing</CardTitle>
            <CardText className="service_desc">
              Digital marketing agency specialised in targetting high-net-worth
              individuals. Our incredible HNWI marketing specialists cater.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">Print media marketing</CardTitle>
            <CardText className="service_desc">
              Such as magazines and newspaper, to reach consumers, business
              customers and prospects.
            </CardText>

            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">SEO</CardTitle>
            <CardText className="service_desc">
              SEO targets unpaid traffic (known as "natural" or "organic"
              results) rather than direct traffic or paid traffic.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
      </Row>
      <Row className="container-services">
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">Interiors Design</CardTitle>
            <CardText className="service_desc desc-last">
              An interior designer is someone who plans, researches,
              coordinates, and manages such enhancement projects.
            </CardText>
            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
        <Col sm="4">
          <Card body className="service">
            <CardTitle tag="h5">Email Marketing</CardTitle>
            <CardText className="service_desc desc-last">
              Aware of new products, discounts and other services. It can also
              be a softer sell to educate your audience on the value of your
              brand or keep them engaged between purchases.
            </CardText>

            <Button href="/contact">Contact Us</Button>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Services;
